import React, { Component } from "react";
import PropTypes from "prop-types";
import "./SearchBox.css";

class SearchBox extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.focusInput = this.focusInput.bind(this);
  }

  focusInput = () => {
    if(this.props.value.length === 0) {
      this.searchInput.value = "";
    }
    this.searchInput.focus();
  };

  render() {
    const {
      className,
      label,
      children,
      iconPosition,
      isBorder,
      icon,
      iconInside,
      clearIcon,
      placeholder,
      ...other
    } = this.props;
    const positionClass =
      iconPosition === "right"
        ? "searchbox__position-right"
        : "searchbox__position-left";
    const borderClass = isBorder ? " bordered" : " no-border";
    const iconInsideClass = iconInside ? " icon-inside" : " icon-outside";
    //const hideInput = this.props.searchParam.length === 0? " hideInput":"";

    return (
      <div className={"ui-searchbox " + className}>
        <span className="form-error-message">{children}</span>
        <div className={positionClass + iconInsideClass} onClick={this.focusInput}>
          <div className="searchbox__icon">
            <img src={icon} onClick={this.focusInput} />
          </div>
          <div className={"searchbox__content" + borderClass}>
            <input
              ref={input => (this.searchInput = input)}
              type="text"
              {...other}
              className={this.props.inValid}
              placeholder={placeholder}
            />
          </div>
          {this.props.value !== "" && iconInside ? (
            <div className="searchbox__clear">
              <img src={clearIcon} onClick={this.props.clearInput} />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

SearchBox.defaultProps = {
  icon: "",
  iconPosition: "right",
  isBorder: true,
  iconInside: false
};

SearchBox.propTypes = {
  /** The icon name to be rendered. */
  icon: PropTypes.string,
  iconPosition: PropTypes.oneOf(["left", "right"]),
  isBorder: PropTypes.bool,
  iconInside: PropTypes.bool
};

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/UI/SearchBox/SearchBox.js